import { object } from 'common/helpers'


export const initialState = {
  isFetching: false,
  products: [],
  productsByTag: {},
  brandsByAlphabet: [],
  productRecommendations: {},
  selectedItems: [],
}

export const setFetching = (state, payload) => (
  object.set(state, 'isFetching', payload)
)

export const selectItem = (state, payload /* payload = item.id */) => (
  object.update(state, 'selectedItems', (selectedItems) => {
    const newSelectedItems = selectedItems.slice()
    newSelectedItems.push(payload)
    return newSelectedItems
  })
)

export const updateProductRecommendations = (state, payload /* payload = item.id */) => (
  object.setIn(state, [ 'productRecommendations', payload.id ], payload.products)
)

export const deselectItem = (state, payload /* payload = item.id */) => (
  object.update(state, 'selectedItems', (selectedItems) => selectedItems.filter(({ id }) => id !== payload))
)

export const clearSelectedItems = (state) => (
  object.set(state, 'selectedItems', [])
)

export const setBrandsByAlphabet = (state, payload) => (
  object.set(state, 'brandsByAlphabet', payload)
)

export const setProducts = (state, payload) => (
  object.set(state, 'products', payload)
)

export const clearProducts = (state) => (
  object.set(state, 'products', [])
)

export const setProductsByTag = (state, payload) => (
  object.set(state, 'productsByTag', payload)
)

export const setSelectedItems = (state, payload) => (
  object.set(state, 'selectedItems', payload)
)

export const updateProducts = (state, payload) => (
  { ...state, products: [ ...state.products, ...payload ], isFetching: false }
)
